import {Component, Input} from '@angular/core';
import {StatusTag} from "@components/ui/status-tag/status-tag";
import {ServerTranslateService} from "@services/server-translate.service";
import {BID_STATUS_USES, BID_ICON_STATUS, BID_SEVERITY_STATUS} from '@shared/data/bid-status-uses-data';

@Component({
  selector: 'app-request-status',
  templateUrl: './request-status.html',
  standalone: true,
  styleUrl: './request-status.css',
  imports: [
    StatusTag

  ]
})
export class RequestStatus {

  @Input() statusId!: number;

  constructor(private serverTranslateService: ServerTranslateService) {

  }
  get statusLabel(): string {
    const status = BID_STATUS_USES.find((s) => s.id === this.statusId);
    return status ? this.serverTranslateService.translate(status, 'names') as string : 'Unknown';
  }

  get statusIcon(): { piIcon?: string; iconSvgPath?: string } {
    const icon = BID_ICON_STATUS[this.statusId];
    if (icon?.startsWith('pi-')) {
      return { piIcon: icon };
    } else {
      return { iconSvgPath: icon };
    }
  }

  get statusSeverity(): string {
    return BID_SEVERITY_STATUS[this.statusId] || 'info';
  }
}
